export default __webpack_public_path__ + "static/media/3341.06f5d6d4.svg";